module.exports = __webpack_public_path__ + "img/chargingport_300.a1644033.png";